import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { AddressData } from './address.api'
import { ContactData } from './contact.api'
import { ItemData } from './item.api'
import { ContactSiteItemData } from './contactSiteItem.api'

export interface ContactSiteData {
  id: number
  contactId: number
  addressId: number
  name: string
  contactSiteItem?: ContactSiteItemData
  items?: ItemData[]
  contact?: ContactData
  address?: AddressData
}

export interface ContactSiteCreateRequest {
  contact?: number
  name?: string
  address?: string
  city?: string
  state?: string
  zip?: string
}

const routes = {
  listItems: '/contactSites/{id}/items',
  create: '/contactSites'
}

export default {
  listItems (id: number, callback: ResponseCallback<ItemData[]>) {
    const url = routeUtil.replaceParams(routes.listItems, { id })
    api.get(url, {}, callback)
  },

  create (
    payload: ContactSiteCreateRequest,
    callback: ResponseCallback<ContactSiteData>
  ) {
    api.post(routes.create, payload, callback)
  }
}
